import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import utils from 'utils';
import { sanitize } from 'utils/validation';
import { getReservationVolatileCurrencyIndicator } from 'selectors/reservationSelectors';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';

/**
 * CurrencyConversionModal - View Currency Conversion Details
 * @param {object} props - React Props
 * @return {JSX}
 */
const CurrencyConversionModal = ({ closeCurrencyConversionModal }) => {
  const isNADomain = utils.config.isNADomain();
  const reservationVolatileCurrencyIndicator = useSelector(getReservationVolatileCurrencyIndicator);

  // update currency conversion modal data based on domain and volatile price flag
  const CurrencyModalContent = () => {
    const region = isNADomain ? 'na' : 'eu';
    const volatility = reservationVolatileCurrencyIndicator ? '_volatile' : '';
    const translationKey = `currency_conversion_copy_${region}${volatility}`;
    const keyValueWithHtmlContent = utils.i18n(translationKey);

    return <p className='modal-themed__copy' dangerouslySetInnerHTML={sanitize(keyValueWithHtmlContent)} />;
  };

  const handleGoBackOnClose = () => {
    if (closeCurrencyConversionModal)
      setTimeout(() => {
        closeCurrencyConversionModal();
      }, 0);
  };
  return (
    <Modal
      modalKey={MODAL.CURRENCY_CONVERSION_DETAILS_MODAL}
      theme={MODAL_THEMES.WHITE}
      customActionOnClose={handleGoBackOnClose}
      header={utils.i18n('vehicle_select_currency_conversion_details')}
    >
      <CurrencyModalContent />
    </Modal>
  );
};

export default CurrencyConversionModal;

CurrencyConversionModal.propTypes = {
  closeCurrencyConversionModal: PropTypes.func,
};
